import React, { useState, useEffect } from 'react';
import { TituloMenu, ColFlex, ColFlexColumn, RowStyle, DivPedidoContenido, DivFlexColumn } from './style'
import { Row, Col, List, Card, Input, Button, Drawer, Icon, Tag, Select, DatePicker } from 'antd'
import { Link } from 'react-router-dom'
import useWindowSize from '../../assets/js/use-windows-size';
import NumberFormat from 'react-number-format';
import RevisarOrden from './forms/RevisarOrden';
import { actionGetOrdenes, actionGetOrden, actionRevisarOrden } from '../../store/acciones/accionesOrdenes';
import { useSelector, useDispatch } from 'react-redux';
import CONSTANTES from '../../store/constantes';
import moment  from 'moment';

const { Search } = Input;
const { Option } = Select;
const { MonthPicker } = DatePicker;

const filtersUser = (usuario) => {
    if (usuario.user_permissions && usuario.user_permissions.length > 0) {
        let permisoUsuario = usuario.user_permissions[0].codename
        switch (permisoUsuario) {
            case "surtidor":
                return {
                    status_orden: [
                        {
                            value: 'a',
                            label: 'APROBADA'
                        },
                        // {
                        //     value: 'v',
                        //     label: 'VALIDADA'
                        // },
                        {
                            value: 's',
                            label: 'SURTIDA'
                        },
                        {
                            value: 'i',
                            label: 'SURTIDA INCOMPLETO'
                        }
                    ],
                    tipo_orden: [
                        {
                            value: 'CONTADO',
                            label: 'CONTADO'
                        },
                        {
                            value: 'CREDITO',
                            label: 'CREDITO'
                        },
                        {
                            value: 'ANTICIPADO',
                            label: 'ANTICIPADO'
                        }                
                    ]
                }
            case "validador":
                return {
                    status_orden: [
                        {
                            value: 'a',
                            label: 'APROBADA'
                        },
                        {
                            value: 'v',
                            label: 'VALIDAR'
                        },
                        {
                            value: 'c',
                            label: 'CANCELADA'
                        },

                    ],
                    tipo_orden: [
                        {
                            value: 'ANTICIPADO',
                            label: 'ANTICIPADO'
                        },
                    ]
                }
            case "cajero":
                console.log("hola cajero")
                break;
            default:
                break;
        }
    }
    return {
        status_orden: [
            {
                value: 'g',
                label: 'GENERADA'
            },
            {
                value: 'a',
                label: 'APROBADA'
            },
            {
                value: 'c',
                label: 'CANCELADA'
            },
            {
                value: 'v',
                label: 'VALIDADA'
            },
            {
                value: 's',
                label: 'SURTIDA'
            },
            {
                value: 'i',
                label: 'SURTIDA INCOMPLETO'
            },
        ],
        tipo_orden: [
            {
                value: 'CONTADO',
                label: 'CONTADO'
            },
            {
                value: 'ANTICIPADO',
                label: 'ANTICIPADO'
            },
            {
                value: 'CREDITO',
                label: 'CREDITO'
            }
        ]

    }
}

const OrdenesList = (props) => {
    const size = useWindowSize();
    const [visibleSider, showSider] = useState(false)
    //const [dataOrden, getDataOrden]=useState()
    const [isMobile, windowResize] = useState(false)

    //Se obtienen las ordenes desde nuestra store usando useSelector
    const ordenes = useSelector(state => state.reducerOrdenes.ordenes);
    const totalPaginas = useSelector(state => state.reducerOrdenes.total);
    let usuario = useSelector(state => state.reducerUsuario.usuario)
    let detailOrden = useSelector(state => state.reducerOrdenes.orden);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actionGetOrdenes(1, null));
        //windowResize({isMobile:size.width<=360?true:false})
    }, [dispatch]);


    const openFormOrden = (orden) => {
        dispatch(actionGetOrden(orden.id));
        showSider(true)
    }

    const editarOrden = (values) => {
        setTimeout(() => {
            dispatch(actionRevisarOrden(values))
            showSider(false)
        }, 1000);
    }

    const getStatus = (status) => {
        switch (status) {
            case "g":
                return <Tag color="green"><Icon type="heat-map" style={{ fontSize: '20px' }} /> Generada</Tag>
            case "a":
                return <Tag color="blue"><Icon type="heat-map" style={{ fontSize: '20px' }} /> Aprobada</Tag>
            case "c":
                return <Tag color="red"><Icon type="heat-map" style={{ fontSize: '20px' }} /> Cancelada</Tag>
            case "v":
                return <Tag color="gold"><Icon type="heat-map" style={{ fontSize: '20px' }} /> Validar</Tag>
            case "s":
                return <Tag color="geekblue"><Icon type="heat-map" style={{ fontSize: '20px' }} /> Surtida</Tag>
            case "i":
                return <Tag color="orange"><Icon type="heat-map" style={{ fontSize: '20px' }} /> Surtida Incompleto</Tag>
            default:
                break;
        }
    }

    const [cadenaSearh, setCadenaSearch] = useState(null)
    const [tipoOrden, setTipoOrden] = useState({ string: '', value: null });
    function handleTipoOrden(value) {
        if (value) {
            const string = `tipoorden=${value}&`;
            setTipoOrden({ string, value });
        } else {
            setTipoOrden({ string: '', value: null });
        }
    }
    const [statusOrden, setStatusOrden] = useState({ string: '', value: null });
    function handleStatusOrden(value) {
        if (value) {
            const string = `status_orden=${value}&`;
            setStatusOrden({ string, value });
        } else {
            setStatusOrden({ string: '', value: null });
        }
    }

    const filterOrdenes = (page, value) => {
        let cadenaclean
        let valueSearch = []
        if (value) {
            cadenaclean = `search=${value}&`.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            if (usuario && usuario.user_permissions && usuario.user_permissions.length > 0) {
                let permisoUsuario = usuario.user_permissions[0].codename
                switch (permisoUsuario) {
                    case "surtidor":
                        console.log('ValueSearhSurtidor', `${cadenaclean}`)
                        valueSearch.push(`${cadenaclean}`)
                        break;
                    case "validador":
                        valueSearch.push(`status_orden=a&${cadenaclean}`)
                        break;
                    default:
                        break;
                }
            }
            else {
                valueSearch.push(cadenaclean)
            }
        }

        valueSearch = [...valueSearch, tipoOrden.string, statusOrden.string].filter(
            (item, index) => {
                return item !== '';
            }
        );
        if (valueSearch.length > 0) {
            let string;
            if (valueSearch.length <= 1) {
                string = valueSearch[0].slice(0, valueSearch[0].length - 1);
                dispatch(actionGetOrdenes(page, string));
            } else {
                const last = valueSearch[valueSearch.length - 1];
                valueSearch[valueSearch.length - 1] = last.slice(0, last.length - 1);
                dispatch(actionGetOrdenes(page, valueSearch.join('')))
            }
        } else {
            dispatch(actionGetOrdenes(page, valueSearch));
        }
        //dispatch(actionGetOrdenes(e.target.value));
    }

    function onChange(date, dateString) {
        setCadenaSearch(dateString)
    }


    return (
        <>
            <TituloMenu>Ordenes Pendientes</TituloMenu>
            {/* ---------------------------Filtros de Ordenes----------------------------- */}
            <RowStyle type="flex" justify="space-around" align="middle">
                <ColFlex xl={8} lg={8} md={8} sm={12} xs={24}>
                    <Search placeholder="Numero de orden, cliente" onChange={(e) => { setCadenaSearch(e.target.value) }} enterButton />
                </ColFlex>

                <ColFlex xl={4} lg={4} md={4} sm={12} xs={24}>
                    <Select size="small" placeholder="Status orden" style={{ width: "80%" }} onChange={handleStatusOrden} value={statusOrden.value}>
                        <Option value={null}>Status Orden</Option>
                        {filtersUser(usuario).status_orden.map((item, index) => {
                            return <Option key={index} value={item.value}>{item.label}</Option>
                        })}
                    </Select>
                </ColFlex>
                <ColFlex xl={4} lg={4} md={4} sm={12} xs={24}>
                    <Select size="small" placeholder="Tipo de orden" style={{ width: "80%" }} onChange={handleTipoOrden} value={tipoOrden.value}>
                        <Option value={null}>Tipo de orden</Option>
                        {filtersUser(usuario).tipo_orden.map((item, index) => {
                            return <Option key={index} value={item.value}>{item.label}</Option>
                        })}
                    </Select>
                </ColFlex>

                <ColFlexColumn xl={4} lg={4} md={4} sm={4} xs={4}>
                    <p style={{ fontSize: 11, fontWeight: 600 }}>Filtrar ordenes por  mes y año</p>
                    <MonthPicker size="small" onChange={onChange} placeholder="Seleccionar Mes" />
                </ColFlexColumn>
                <ColFlex xl={4} lg={4} md={4} sm={12} xs={24}>
                    <Button type="primary" icon="search" size="default" onClick={() => filterOrdenes(1, cadenaSearh)}>
                        Filtrar
                    </Button>
                </ColFlex>

                {/* <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                    <MonthPicker onChange={onChange} placeholder="Seleccionar Mes" />
                </ColFlex> */}
            </RowStyle>

            <Row type="flex" justify="space-around" align="middle">
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <List
                        pagination={{
                            total: totalPaginas,
                            onChange: page => {
                                filterOrdenes(page, cadenaSearh)
                            },
                            pageSize: 50,
                            position: 'top'
                        }}
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 1,
                            md: 1,
                            lg: 2,
                            xl: 2,
                            xxl: 2,
                        }}
                        dataSource={ordenes}
                        renderItem={item => (
                            <List.Item>
                                <Card title={false} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col lg={24} xs={24} style={{ paddingTop: 5, paddingBottom: 0 }}><p style={{ fontSize: 18, fontWeight: "600" }}><Icon type="user" style={{ marginRight: ".5em" }} />{item.cliente.NOMBRE} (CODIGO:{item.cliente.CODIGO}) </p>  </Col>
                                        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
                                            <DivPedidoContenido>
                                                <p><Icon type="number" style={{ marginRight: ".5em", fontSize:20 }} /><span style={{fontSize:20, fontWeight:700 }}> {item.numerodeorden}</span></p>
                                                <p><Icon type="calendar" style={{ marginRight: ".5em" }} /><span>{moment(item.fechageneracion).format("D MMMM YYYY, h:mm a")}</span></p>
                                                <p><Icon type="credit-card" style={{ marginRight: ".5em" }} /><span>{item.tipoorden}</span></p>
                                            </DivPedidoContenido>
                                        </Col>
                                        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
                                            <DivPedidoContenido>
                                                <p>Status:{getStatus(item.status)}</p>
                                                <p>Total:<span style={{fontSize:18, fontWeight:700}}><NumberFormat  value={item.total} displayType={'text'} thousandSeparator={true} prefix={'$'} fixedDecimalScale={true} decimalScale={2} /></span></p>
                                                {/* <p>Vendedor: <span>{item.vendedor}</span></p> */}
                                            </DivPedidoContenido>
                                        </Col>
                                        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
                                            <DivFlexColumn column>
                                                <DivFlexColumn >
                                                    <Link to={`${props.match.url}/${item.id}`} >
                                                        <Button size="small" type="primary" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                            <Icon type="eye" style={{ fontSize: "18px" }} />
                                                            <span style={{ fontSize: "12px" }}>Ver más</span>
                                                        </Button>
                                                    </Link>
                                                </DivFlexColumn>
                                                <br />
                                                <DivFlexColumn >
                                                    <Button size="small" href={`${CONSTANTES.URL_API}/pedidos/pdf/${item.id}/`} target="blank" type="primary" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <Icon type="file-pdf" style={{ fontSize: "18px" }} />
                                                        <span style={{ fontSize: "12px" }}>Descargar PDF</span>
                                                    </Button>
                                                </DivFlexColumn>
                                                <br />
                                                <DivFlexColumn>
                                                    <Button size="small" type="primary" icon="edit" onClick={() => openFormOrden(item)}>Revisar</Button>
                                                </DivFlexColumn>

                                            </DivFlexColumn>
                                        </Col>
                                    </Row>
                                </Card>
                            </List.Item>
                        )}
                    />
                    <Drawer
                        title="Revisar orden"
                        placement="right"
                        closable={false}
                        onClose={() => showSider(false)}
                        visible={visibleSider}
                        width={isMobile.isMobile ? "90%" : "40%"}
                        destroyOnClose

                    >

                        <RevisarOrden registro={editarOrden} data={detailOrden} />

                    </Drawer>
                </Col>
            </Row>
        </>
    );
};


export default OrdenesList